import { GetHousesByQuery } from "@/types/GetHousesByQuery";

export const generateHouseQuery = (
  builderId: string,
  landWidthValue: string | number | null,
  landDepthValue: string | number | null
): GetHousesByQuery => {
  const query: GetHousesByQuery = {
    builderId,
  };

  if (landWidthValue !== "" && typeof landWidthValue === "number") {
    query.width = landWidthValue;
  }

  if (landDepthValue !== "" && typeof landDepthValue === "number") {
    query.length = landDepthValue;
  }

  return query;
};
